// Surfaces extérieures — services & tarifs
// NB : tous les prix ci-dessous sont PROVISOIRES (à ajuster lors de la passe tarifs).
import { Building2, Sun, Trees, Warehouse, Car, Store } from "lucide-react";

// Box / Garage — 2 options au choix (prix fixe)
export const BOX = {
  id: "box",
  name: "Box / Garage",
  desc: "Nettoyage complet du sol et des murs",
  icon: Warehouse,
  options: [
    { id: "1p", label: "1 place", price: 60 },
    { id: "2p", label: "2 places", price: 100 },
  ],
};

// Place de parking — tarif par place (quantité)
export const PARKING = {
  id: "parking",
  name: "Place de parking",
  desc: "Nettoyage par place (copropriété, entreprise…)",
  icon: Car,
  pricePerPlace: 15,
};

// Petites surfaces : tarif au m² (le client saisit sa surface)
export const SURFACES_M2 = [
  { id: "balcon", name: "Balcon", desc: "Sol et garde-corps", pricePerM2: 5, icon: Building2 },
  { id: "terrasse", name: "Terrasse", desc: "Dégraissage, démoussage, haute pression", pricePerM2: 5, icon: Sun },
  { id: "cour", name: "Cour / Allée", desc: "Dalles, pavés, sol extérieur", pricePerM2: 4, icon: Trees },
];

// Grandes surfaces & professionnels : sur devis
export const SURFACES_DEVIS = [
  { id: "local_commercial", name: "Local commercial", desc: "Boutique, bureau, local professionnel", icon: Store },
  { id: "grande_surface", name: "Grande surface", desc: "Parking complet, copropriété, surface importante", icon: Building2 },
];
